import { formatDifferenceInHoursAndMinutesAndSeconds } from '@backoffice-frontend/common'
import { useEffect, useState } from 'react'

type CountUpSinceProps = {
  since?: Date
}

export const useCountUpSince = ({ since }: CountUpSinceProps) => {
  const [currentTime, setCurrentTime] = useState(new Date())

  useEffect(() => {
    let interval: NodeJS.Timeout

    setTimeout(() => {
      interval = setInterval(() => {
        setCurrentTime(new Date())
      }, 1000)
      setCurrentTime(new Date())
    }, 1000 - new Date().getMilliseconds())

    return () => clearInterval(interval)
  }, [])

  if (!since) {
    return ''
  }

  const formattedSince = formatDifferenceInHoursAndMinutesAndSeconds(
    since,
    currentTime,
  )

  return formattedSince
}
